import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import Toasted from "vue-toasted";
import UniqueId from "vue-unique-id";

require("./assets/css/code_widget.css");
require("./assets/css/label_highlight.css");

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");

Vue.use(Toasted, {
  position: "bottom-center",
  duration: 1500,
  className: "toast",
});

Vue.use(UniqueId);
